import * as yup from "yup";

import { IConfirmDocumentsFormFields } from "./pages/confirm-document-page/confirm-document-page";
import { ILoginPasswordForm } from "./pages/login-password-page";
import { IUpdatePasswordFormFields } from "./pages/login-update-password-page/login-update-password-page";
import { IRegisterPhoneFormFields } from "./pages/register-phone-page/register-phone-form/types";

/** Схема валидации формы ввода телефона */
export const registerPhoneFormSchema = yup
  .object()
  .shape<Record<keyof IRegisterPhoneFormFields, yup.AnySchema>>({
    phone: yup
      .string()
      .required("Укажите телефон")
      .test("check-phone", "Неверный телефон", (value) => {
        const preparedValue = value?.replace(/\D/g, "").slice(1) || "";

        return Boolean(preparedValue.match(/\d{10}/));
      }),
  });

/** Схема валидации поля пароль */
export const passwordSchema = yup
  .string()
  .required("Укажите пароль")
  .matches(
    /^[^А-я]+$/,
    "Допустимо использование латинских букв, верхнего и нижнего регистров"
  )
  .matches(/[a-z]/, "Используйте буквы верхнего и нижнего регистров")
  .matches(/[A-Z]/, "Используйте буквы верхнего и нижнего регистров")
  .matches(/[\W_]/, "Используйте хотя бы одну цифру и спецсимвол")
  .matches(/\d/, "Используйте хотя бы одну цифру и спецсимвол")
  .min(
    10,
    "Слишком короткий пароль. Пароль должен содержать не менее 10 символов"
  );

/** Схема валидации поля "Повторите пароль" */
export const retryPasswordSchema = passwordSchema.test(
  "is-same-passwords",
  "Пароли не совпадают",
  (value, context) => {
    return value === (context.parent as IUpdatePasswordFormFields).password;
  }
);

/** Схема валидации формы обновления пароля */
export const updatePasswordFormSchema = yup.object<
  Record<keyof IUpdatePasswordFormFields, yup.AnySchema>
>({
  password: passwordSchema,
  retryPassword: retryPasswordSchema,
});

/** Схема валидации формы восстановления пароля */
export const confirmDocumentFormSchema = yup
  .object()
  .shape<Record<keyof IConfirmDocumentsFormFields, yup.AnySchema>>({
    passport: yup
      .string()
      .required("Заполните 6 цифр номера паспорта")
      .test("check-password", "Заполните 6 цифр номера паспорта", (value) => {
        const preparedValue = value?.replaceAll(/\D/g, "") || "";
        return Boolean(preparedValue.match(/\d{6}/));
      }),
  });

/** Схема валидации формы ввода пароля */
export const loginPasswordFormSchema = yup.object<
  Record<keyof ILoginPasswordForm, yup.AnySchema>
>({
  password: yup.string().required("Укажите пароль"),
});
